import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import CustomerHeader from "../../components/CustomerHeader";
import { Clock, ArrowRight, Package } from "lucide-react";

const STATUS_LABEL = {
  placed: "Order placed", confirmed: "Shop confirmed", ready: "Ready for pickup",
  picked_up: "Rider picked up", on_the_way: "On the way", delivered: "Delivered",
  rejected: "Rejected", cancelled: "Cancelled",
};
const STATUS_TONE = {
  placed: "bg-blue-50 text-blue-700 border-blue-100",
  confirmed: "bg-cyan-50 text-cyan-700 border-cyan-100",
  ready: "bg-cyan-50 text-cyan-700 border-cyan-100",
  picked_up: "bg-amber-50 text-amber-700 border-amber-100",
  on_the_way: "bg-amber-50 text-amber-700 border-amber-100",
  delivered: "bg-emerald-50 text-emerald-700 border-emerald-100",
  rejected: "bg-rose-50 text-rose-700 border-rose-100",
  cancelled: "bg-slate-100 text-slate-700 border-slate-200",
};

export default function OrderHistory() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {}); }, []);

  return (
    <div className="light-scope min-h-screen bg-slate-50" data-testid="order-history-container">
      <CustomerHeader onCartClick={() => {}} />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
        <h1 className="text-3xl font-extrabold text-slate-900">Your orders</h1>
        <p className="text-slate-500 text-sm">Everything you've ordered on STACK.</p>

        {orders.length === 0 && (
          <div className="rounded-2xl bg-white border border-slate-200 p-10 mt-6 text-center" data-testid="orders-empty">
            <Package size={28} className="mx-auto text-emerald-600" />
            <div className="font-bold text-lg mt-3 text-slate-800">No orders yet</div>
            <div className="text-slate-500 text-sm">Place your first order — delivered in 10 minutes.</div>
            <Link to="/app" className="inline-flex mt-5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl px-5 py-2 text-sm font-bold">Start shopping</Link>
          </div>
        )}

        <div className="mt-5 space-y-3">
          {orders.map((o) => (
            <Link key={o.order_id} to={`/orders/${o.order_id}`} className="rounded-2xl bg-white border border-slate-200 hover:border-slate-400 p-4 flex items-center gap-4 transition group" data-testid={`order-row-${o.order_id}`}>
              <div className="w-12 h-12 rounded-xl bg-emerald-50 border border-emerald-100 inline-flex items-center justify-center">
                <Package size={18} className="text-emerald-600" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <div className="font-bold truncate text-slate-900">{o.shop_name}</div>
                  <span className={`text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-full border ${STATUS_TONE[o.status] || ""}`}>{STATUS_LABEL[o.status] || o.status}</span>
                </div>
                <div className="text-xs text-slate-500 inline-flex items-center gap-1.5 mt-0.5">
                  <Clock size={11} /> {new Date(o.created_at).toLocaleString()} · {o.items.length} item{o.items.length > 1 ? "s" : ""}
                </div>
              </div>
              <div className="font-extrabold text-slate-900">₹{o.total.toFixed(2)}</div>
              <ArrowRight size={16} className="text-slate-400 group-hover:text-emerald-600 transition" />
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
